module.exports = __webpack_public_path__ + "img/vertical_3_7_5012.37c4c87a.png";